export default __webpack_public_path__ + "static/media/violetgrass.ecbc1e05.png";